import { GATrackingEventDetail } from '@/types';
import config from './config';

const handleGATracking = (event: any) => {
  const onTracking = config.get('onTracking');
  const { gaEvent, data } = event.detail as GATrackingEventDetail;
  onTracking?.(gaEvent, data);
};

export default handleGATracking;